// extracted by mini-css-extract-plugin
export default {"root":"DdgwQsBJMK","scrollArea":"lPzwfZ28j8"};